import { useState } from 'react';
import API from '@/lib/api';
import { toast } from 'sonner';

export default function LoginPage() {
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      const res = await API.get('/auth/google/start');
      window.location.href = res.data.auth_url;
    } catch (err) {
      toast.error('Failed to start Google sign-in');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex flex-col">
      {/* Full-page background — Miami downtown skyline at night */}
      <img
        src="https://images.unsplash.com/photo-1719427802451-433d1b549832?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxNaWFtaSUyMGRvd250b3duJTIwc2t5bGluZSUyMG5pZ2h0fGVufDB8fHx8MTc3Mzk2MzcyNHww&ixlib=rb-4.1.0&q=85"
        alt="Miami downtown skyline at night"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Company name — top left */}
      <div className="relative z-10 p-8">
        <span className="text-3xl font-bold text-[#0a2540]" style={{ fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.03em', textShadow: '0 0 20px rgba(255,255,255,0.8), 0 0 40px rgba(255,255,255,0.4)' }}>
          WholesaleOffers
        </span>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Google sign-in button — bottom center */}
      <div className="relative z-10 flex justify-center pb-16">
        <button
          data-testid="google-signin-btn"
          onClick={handleGoogleSignIn}
          disabled={loading}
          className="flex items-center justify-center gap-3 h-12 px-8 rounded-xl bg-white hover:bg-gray-50 text-gray-800 font-medium text-sm transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-60 cursor-pointer"
        >
          {loading ? (
            <div className="h-5 w-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <svg className="h-5 w-5" viewBox="0 0 24 24">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Sign in with Google
            </>
          )}
        </button>
      </div>
    </div>
  );
}
